import { Box, Link } from 'theme-ui'

import Type from 'src/components/gel/Type'
import FormattedText from 'src/components/common/formattedText/FormattedText'

export interface TechnicalSpec {
  label: string
  description: string | null
  text: string | null
  link: string | null
}

const TechSpecsSection = ({ specs }: { specs: TechnicalSpec[] }) => {
  const linkPrefix = 'https://'

  return (
    specs.length > 0 && (
      <Box sx={{ py: [6, 6, 6, 11], px: [4], height: 'auto' }}>
        <Box
          sx={{
            display: 'flex',
            flexWrap: 'wrap',
            height: 'auto'
          }}
        >
          <Box
            sx={{
              width: ['100%', '100%', '100%', 'calc(37.5% - 16px)']
            }}
          >
            <Box
              sx={{
                display: 'flex',
                alignItems: 'flex-start',
                height: ['auto'],
                pt: [5, null, 5, 0],
                pb: [5, null, 5, 0]
              }}
            >
              <Type variant="SectionTitleSans">{'Technical Specifications'}</Type>
            </Box>
          </Box>
          <Box
            sx={{
              width: ['100%', '100%', '100%', 'calc(62.5% + 16px)'],
              display: 'block',
              height: ['auto']
            }}
          >
            {specs.map((spec, idx) => {
              const { label, description, link, text } = spec

              return (
                <Box
                  key={idx}
                  sx={{
                    height: 'auto',
                    borderBottom: '1.5px solid #9E9E9E',
                    display: 'flex',
                    py: [2, 2, 2, 4]
                  }}
                >
                  <Box
                    sx={{
                      height: 'auto',
                      width: ['100%', '100%', '100%', 'calc(37.5% - 16px)']
                    }}
                  >
                    <Type variant="BodyEmphasised">{label}</Type>
                  </Box>
                  <Box
                    sx={{
                      width: ['100%', '100%', '100%', 'calc(62.5% + 16px)']
                    }}
                  >
                    {description && <FormattedText text={description} />}
                    {link && (
                      <Link
                        href={(!link.includes(linkPrefix) ? linkPrefix : '') + link}
                        target={'_blank'}
                      >
                        <Type variant="BodyEmphasised" sx={{ textDecorationLine: 'underline' }}>
                          {text || link}
                        </Type>
                      </Link>
                    )}
                  </Box>
                </Box>
              )
            })}
          </Box>
        </Box>
      </Box>
    )
  )
}

export default TechSpecsSection
